import { Button, Dropdown, Input, Table } from "@fluentui/react-northstar";
import styled from "styled-components/macro";

export const DropdownFilter = styled(Dropdown)`
    border-radius: 4px;
    border: 1px solid var(--Neutral-Stroke-1-Rest, #d1d1d1);
    height: fit-content;
    &.category .ui-dropdown__container {
        width: ${({ width }) => width || "184px"};
    }
    .ui-button__content {
        color: var(--Neutral-Foreground-4-Rest, #707070);

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }
`;

export const InputFilter = styled(Input)`
    border-radius: 4px;
    border: 1px solid var(--Neutral-Stroke-1-Rest, #d1d1d1);
    input {
        color: var(--Neutral-Foreground-4-Rest, #707070) !important;
    }
`;

export const ButtonReset = styled(Button)`
    color: var(--Light-theme-Rest-Foreground-Brand-Foreground, #5b5fc7);
    text-align: center;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    text-decoration-line: underline;
    &.disabled {
        color: rgb(199, 199, 199);
        cursor: not-allowed;
    }
`;

export const TableFiles = styled(Table)`
    width: 100%;
    max-height: 480px;
    height: 100%;
    overflow-y: scroll;

    .ui-table__header {
        border-radius: var(--radius-m-4, 4px) var(--radius-m-4, 4px) 0px 0px;
        background: var(
            --Light-theme-Rest-Background-Brand-Background-1,
            #e8ebfa
        );
        display: flex;
        align-items: center;
        align-self: stretch;
        height: 30px;
        .ui-table__cell__content {
            color: var(
                --light-theme-rest-foreground-default-foreground-1424242,
                #424242
            );

            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px; /* 142.857% */
        }
        /* padding: var(--spacing-ixxs-4, 4px) var(--spacing-xl-32, 32px)
            var(--spacing-ixxs-4, 4px) 10px; */
        /* gap: var(--spacing-m-16, 16px); */
    }
    [role="row"].ui-table__row:not(.ui-table__header) {
        background-color: white;
        cursor: pointer;
        min-height: 40px;
        :hover {
            background-color: #f5f5f5;
        }
    }
    [role="row"].ui-table__row.checked:not(.ui-table__header) {
        background-color: #ebebeb;
    }
    [data-recent="recent"] {
        background-color: #e4f1fb !important;
    }
`;
